// The site's own script (spec D7), loaded as a module by every page, 404 included. Each
// init does nothing on a page without its elements.

import { initAccordion } from "./accordion.js";
import { initContact } from "./contact.js";
import { initFooterYear } from "./footer-year.js";
import { initMenu } from "./menu.js";
import { initModals } from "./modals.js";
import { initReveal, initTints } from "./motion.js";
import { initAnchors } from "./scroll.js";

initReveal();
initTints();
initMenu();
initAccordion();
initModals();
initContact();
initFooterYear();
initAnchors();
